<template>
  <div>
    <div class="tab-title">{{ tabTitle }}</div>
    <div class="feed-list-container" v-loading="feedShade">
      <FeedItem
        v-for="feed in feedList"
        :key="feed.modelId"
        :feed="feed"
        :page="feedPage"
      />
      <p class="no-feed" v-if="feedList.length == 0">{{ noFeedText }}</p>
    </div>
    <div class="pagination-wrapper">
      <el-pagination
        layout="prev, pager, next"
        :total="totalPage"
        prev-text="上一页"
        next-text="下一页"
        hide-on-single-page
        ref="pagination"
        @current-change="curtListPageClick"
      >
        <!-- @prev-click="prevtListPageClick" -->
        <!-- @next-click="nextListPageClick" -->
      </el-pagination>
    </div>
    <ShareHandLian />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { apiMap } from "../../utils/apiMap";
import FeedItem from "../../components/user/feed/feed-item";
import ShareHandLian from "../../components/ShareHandLian";
import { reviewTime } from "../../utils/date";
export default {
  name: "user-feed",
  data() {
    return {
      feedShade: true,
      feedPage: 1,
      feedList: [],
      feedTotal: 0,
      noFeedText: "",
      tabTitle: "动态列表",
    };
  },
  components: {
    FeedItem,
    ShareHandLian,
  },
  computed: {
    ...mapGetters(["userCenterSign"]),
    totalPage() {
      return this.feedTotal;
    },
  },
  mounted() {
    this.feedPage = this.userCenterSign.feedPage || 1;
    this.getUserFeed(this.feedPage);
    this.$bus.$on("withdraw-feed", this.withdrawOnFriend);
    this.$bus.$on("withdraw-community", this.withdrawOnCommunity);
  },
  methods: {
    getUserFeed(start) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let fetchId = this.$route.query.id;
      var numberRegExp = /^[0-9]+$/;
      if (!numberRegExp.test(fetchId)) {
        return false;
      }
      let params = `token=${loginUser.token}&friendUserId=${fetchId}&start=${start}&count=10`;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["friendFeed"]["method"],
          url: apiMap["friendFeed"]["url"],
          data: params,
        })
        .then(function(response) {
          _this.feedShade = false;
          if (response.data.result.statusCode == 1) {
            var feedBuffer = response.data.result.data;
            var tampList = [];
            for (let index = 0; index < feedBuffer.length; index++) {
              const element = feedBuffer[index];
              //动态列表不显示视频、音频
              if ([3, 4].includes(element.article)) {
                continue;
              }
              var diffTime =
                response.data.result.requestTime - element.created_at;
              if (diffTime > reviewTime) {
                //已经通过审核的动态
                tampList.push(element);
                // _this.feedList.push(element);
              }
            }
            _this.feedList = tampList;
            _this.feedTotal = response.data.result.count;
            _this.$refs.pagination.internalCurrentPage = start;
          } else {
            _this.noFeedText = "暂无动态";
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    withdrawOnFriend(id, type) {
      if (id && type) {
        this.unShareFeed(id, type, "shareFriends");
      }
    },
    withdrawOnCommunity(id, type) {
      if (id && type) {
        this.unShareFeed(id, type, "sharePublic");
      }
    },
    unShareFeed(feedID, feedType, area) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      let requestUrl = "";
      let method = "";
      let params = "";
      switch (feedType) {
        case 1:
          requestUrl = apiMap["articleShare"]["url"];
          method = apiMap["articleShare"]["method"];
          params = `token=${loginUser.token}&articleId=${feedID}&shareField=${area}&shareValue=0`;
          break;
        case 2:
          requestUrl = apiMap["albumShare"]["url"];
          method = apiMap["albumShare"]["method"];
          params = `token=${loginUser.token}&photoId=${feedID}&shareField=${area}&shareValue=0`;
          break;
        case 3:
          requestUrl = apiMap["musicShare"]["url"];
          method = apiMap["musicShare"]["method"];
          params = `token=${loginUser.token}&musicId=${feedID}&shareField=${area}&shareValue=0`;
          break;
        case 4:
          requestUrl = apiMap["videoShare"]["url"];
          method = apiMap["videoShare"]["method"];
          params = `token=${loginUser.token}&videoId=${feedID}&shareField=${area}&shareValue=0`;
          break;
      }
      _this
        .$axios({
          method: method,
          url: requestUrl,
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var findIndex = -1;
            _this.feedList.filter((item, index) => {
              if (item.modelId == feedID && item.article == feedType) {
                findIndex = index;
              }
            });
            if (findIndex != -1) {
              _this.feedList.splice(findIndex, 1);
              _this.$message({
                message: "操作成功！",
                type: "success",
              });
            }
          } else {
            _this.$message({
              message: "操作失败，稍后再试",
              type: "warning",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    prevtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      // this.getUserFeed(newPage);
    },
    curtListPageClick(newPage) {
      //即将加载的起始页
      this.feedPage = newPage;
      this.getUserFeed(newPage);
    },
    nextListPageClick(newPage) {
      this.feedPage = newPage;
      console.log(newPage);
      // this.getUserFeed(newPage);
    },
  },
  watch: {
    $route(to, from) {
      //监听路由是否变化
      if (to.query.id != from.query.id) {
        const initUserSign = {
          feedPage: 1,
          articlePage: 1,
          albumPage: 1,
          audioPage: 1,
          videoPage: 1,
        };
        Store.dispatch("setUserCenterSign", initUserSign);
        this.$refs.pagination.internalCurrentPage = 1;
        this.feedShade = true;
        this.feedPage = 1;
        this.feedList = [];
        this.getUserFeed(1);
      }
    },
  },
};
</script>
<style scoped>
.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.feed-list-container {
  min-height: 80px;
}

.no-feed {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper {
  margin-bottom: 15px;
  padding: 5px 0;
  text-align: center;
  background-color: #fff;
}

.pagination-wrapper:empty {
  padding: 0;
}
</style>
